/** Rótulo do perfil sem permissões associadas, usado na listagem e nos pop-ups. */
export const NO_PERMISSIONS_LABEL = "sem permissões";
